import React from 'react';
import { useI18n } from '../i18n/I18nContext';
import './LegalPage.css';

const CONTACT_EMAIL = 'flashagency1@outlook.com';
const CONTACT_PHONE = '+852 52134313';

function AboutUs() {
  const { t } = useI18n();

  return (
    <div className="legal-page">
      <h1 className="legal-page__title">{t('legal.about.title')}</h1>
      <p className="legal-page__subtitle">{t('legal.about.subtitle')}</p>

      <section className="legal-page__section">
        <h2>{t('legal.about.positionTitle')}</h2>
        <p>{t('legal.about.positionText')}</p>
      </section>

      <section className="legal-page__section">
        <h2>{t('legal.about.offerTitle')}</h2>
        <ul>
          <li>{t('legal.about.offerItem1')}</li>
          <li>{t('legal.about.offerItem2')}</li>
          <li>{t('legal.about.offerItem3')}</li>
        </ul>
      </section>

      <section className="legal-page__section">
        <h2>{t('legal.about.visionTitle')}</h2>
        <p>{t('legal.about.visionText')}</p>
      </section>

      <section className="legal-page__section">
        <h2>{t('legal.about.qualityTitle')}</h2>
        <ul>
          <li>{t('legal.about.qualityItem1')}</li>
          <li>{t('legal.about.qualityItem2')}</li>
          <li>{t('legal.about.qualityItem3')}</li>
        </ul>
      </section>

      <section className="legal-page__section">
        <h2>{t('legal.about.deliveryTitle')}</h2>
        <p>{t('legal.about.deliveryText')}</p>
      </section>

      <section className="legal-page__section legal-page__contact">
        <h2>{t('legal.contact.title')}</h2>
        <p>{t('footer.title')}</p>
        <p>{t('footer.companyName')}</p>
        <p>{t('footer.address')}</p>
        <p>
          {t('footer.emailLabel')}: {CONTACT_EMAIL}
        </p>
        <p>
          {t('footer.phoneLabel')}: {CONTACT_PHONE}
        </p>
      </section>
    </div>
  );
}

export default AboutUs;
